export default __webpack_public_path__ + "static/media/outlook.605ccf52.svg";